import React, { useState } from 'react';
import { Modal, ModalBody, ModalHeader } from 'reactstrap';
import AddAddressForm from './AddAddressForm';

/**
 * Modal genérico para adicionar endereços a Contas ou Contatos
 * @param {string} entityType - Tipo de entidade: 'contact' ou 'account'
 * @param {string} entityId - ID da entidade (contactId ou accountId)
 * @param {object} entity - Dados da entidade (contact ou account)
 * @param {function} onAddedAddress - Callback chamado após adicionar endereço
 * @param {function} buttonOpenModal - Render prop para customizar o botão de abrir modal
 */
function AddAddressModal({
  entityType = 'contact',
  entityId,
  entity,
  onAddedAddress,
  buttonOpenModal
}) {
  const [isOpen, setIsOpen] = useState(false);

  const handleOpenModal = () => {
    setIsOpen(true);
  };

  const handleCloseModal = () => {
    setIsOpen(false);
  };

  const handleAddedAddress = () => {
    onAddedAddress();
    setIsOpen(false);
  };

  return (
    <>
      {buttonOpenModal && buttonOpenModal({ onClick: handleOpenModal })}

      <Modal isOpen={isOpen} toggle={handleCloseModal} size="lg">
        <ModalHeader toggle={handleCloseModal}>Adicionar Endereço</ModalHeader>
        <ModalBody>
          <AddAddressForm
            entityType={entityType}
            entityId={entityId}
            entity={entity}
            onAddedAddress={handleAddedAddress}
            onCancel={handleCloseModal}
          />
        </ModalBody>
      </Modal>
    </>
  );
}

export default AddAddressModal;
